export default __webpack_public_path__ + "static/media/clockOpenBill.4e47c2fe.svg";